import { Action } from 'models/index.m';
import actionsTypes from 'store/actionTypes';

export const setAIChatState = (data: boolean): Action<boolean> => ({
  type: actionsTypes.SET_AI_CHAT_STATE,
  payload: data,
});

export const setAIChatContextId = (
  data: string | null,
): Action<string | null> => ({
  type: actionsTypes.SET_AI_CHAT_CONTEXT_ID,
  payload: data,
});

export const setAIChatHistory = (data: any[]): Action<any[]> => ({
  type: actionsTypes.SET_AI_CHAT_HISTORY,
  payload: data,
});

export const setAIChatLoading = (data: boolean): Action<boolean> => ({
  type: actionsTypes.SET_AI_CHAT_LOADING,
  payload: data,
});

export const setAIChatError = (data: string | null): Action<string | null> => ({
  type: actionsTypes.SET_AI_CHAT_ERROR,
  payload: data,
});
